export const environment = {
  production: false,
  urlAPI: 'https://dev-api-wab.lnkgs.es/api/',
  urlBase: 'https://dev-api-wab.lnkgs.es/',
  blobPublic: 'https://blobwhatsappbusiness.blob.core.windows.net/dev-whatsappbusiness-public',
  urlApp: 'https://dev-wab.lnkgs.es/'
};
